import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import classnames from 'classnames';
import { eachMonthOfInterval, startOfYear, endOfYear, isSameMonth, format, startOfMonth, endOfMonth } from 'date-fns';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { useIntervalPicker } from './useIntervalPicker.js';
import { s as styles } from './date-picker-DxEXPS6T.js';
import 'react';

const MONTHS_IN_ROW = 3;
const MonthPicker = ({ displayDate, selectedDate, onDateSelect, locale }) => {
    const dates = eachMonthOfInterval({ start: startOfYear(displayDate), end: endOfYear(displayDate) });
    const forceDisabled = useDisabled();
    return (jsx("div", { className: classnames(styles.calendar, styles.calendarMonths), "data-qa": "date-picker-months", children: dates.map((date) => {
            const isSelected = !!selectedDate && isSameMonth(date, selectedDate);
            const isCurrentMonth = isSameMonth(date, Date.now());
            return (jsx("div", { className: styles.item, children: jsx("button", { className: classnames(styles.text, {
                        [styles.textDisabled]: forceDisabled,
                        [styles.textSelected]: isSelected,
                        [styles.textToday]: isCurrentMonth,
                        [styles.textUnselected]: !forceDisabled && !isSelected,
                    }), onClick: () => onDateSelect?.(date), "data-month": format(date, 'yyyy-MM'), "data-qa": classnames('date-picker-month', {
                        'date-picker-month-disabled': forceDisabled,
                        'date-picker-month-selected': isSelected,
                        'date-picker-month-current': isCurrentMonth,
                    }), children: format(date, 'LLLL', { locale }) }) }, `${date}`));
        }) }));
};
const IntervalMonthPicker = ({ displayDate, selectionStart, selectionEnd, onStartSelect, onEndSelect, locale, }) => {
    const dates = eachMonthOfInterval({ start: startOfYear(displayDate), end: endOfYear(displayDate) });
    const datesProps = useIntervalPicker({
        dates,
        selectionStart: selectionStart && startOfMonth(selectionStart),
        selectionEnd: selectionEnd && endOfMonth(selectionEnd),
        onStartSelect,
        onEndSelect,
        isEqual: isSameMonth,
    });
    return (jsx("div", { className: classnames(styles.calendar, styles.calendarMonths), "data-qa": "date-picker-months", children: dates.map((date, index) => {
            const { isDisabled, isIntervalStart, isIntervalEnd, isSelected, isWithinInterval, mouseHandlers } = datesProps[index];
            const isIntervalRowStart = isWithinInterval && !isIntervalStart && index % MONTHS_IN_ROW === 0;
            const isIntervalRowEnd = isWithinInterval && !isIntervalEnd && index % MONTHS_IN_ROW === MONTHS_IN_ROW - 1;
            const isCurrentMonth = isSameMonth(date, Date.now());
            return (jsxs("div", { className: classnames(styles.item, {
                    [styles.itemInterval]: isWithinInterval,
                    [styles.itemIntervalStart]: isIntervalStart,
                    [styles.itemIntervalEnd]: isIntervalEnd,
                    [styles.itemIntervalRowStart]: isIntervalRowStart,
                    [styles.itemIntervalRowEnd]: isIntervalRowEnd,
                }), children: [jsx("button", { ...mouseHandlers, className: classnames(styles.text, {
                            [styles.textDisabled]: isDisabled,
                            [styles.textSelected]: isSelected,
                            [styles.textToday]: isCurrentMonth,
                            [styles.textUnselected]: !isDisabled && !isSelected,
                        }), "data-month": format(date, 'yyyy-MM'), "data-qa": classnames('date-picker-month', {
                            'date-picker-month-disabled': isDisabled,
                            'date-picker-month-selected': isSelected,
                            'date-picker-month-current': isCurrentMonth,
                        }), children: format(date, 'LLLL', { locale }) }), isWithinInterval && jsx("div", { className: styles.substrate })] }, `${date}`));
        }) }));
};

export { IntervalMonthPicker, MonthPicker };
//# sourceMappingURL=MonthPicker.js.map
